import { Button, Popconfirm, type ButtonProps } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

interface ConfirmDeleteButtonProps extends Omit<ButtonProps, 'onClick'> {
  onConfirm: () => void;
  title?: string;
  description?: string;
}

export function ConfirmDeleteButton({
  onConfirm,
  title = 'Supprimer ?',
  description = 'Cette action est irréversible.',
  children,
  ...buttonProps
}: ConfirmDeleteButtonProps) {
  return (
    <Popconfirm title={title} description={description} onConfirm={onConfirm} okText="Oui" cancelText="Non">
      <Button danger icon={<DeleteOutlined />} {...buttonProps}>
        {children ?? 'Supprimer'}
      </Button>
    </Popconfirm>
  );
}
